import { Employee } from '~types/company';
import { getRankingGroup, RankingGroupText } from '~utils/company/company';

import { Summary } from '../style';

interface Props {
  employee: Employee;
}

function getEmployeeType(employee: Employee) {
  return {
    rateType: employee.rateType,
    rate: employee.rateType === 'INDUSTRY' ? employee.industryRate : employee.totalRate,
  };
}
function EmployeeSummary({ employee }: Props) {
  const employeeType = getEmployeeType(employee);
  const rankingGroup = getRankingGroup(employeeType.rate);

  if (!employeeType.rate) return null;

  if (!rankingGroup) {
    return null;
  }
  const text = `인원 규모가 ${
    employeeType.rateType === 'INDUSTRY' ? '동종업계' : '전체'
  }에서 <span>${RankingGroupText[rankingGroup]}</span>인 기업이에요`;

  return <Summary dangerouslySetInnerHTML={{ __html: text }} />;
}

export default EmployeeSummary;
